import React from "react";
import "./AccessDenied.scss";
import { useTranslation } from "react-i18next";

interface IProps {}

export default function AccessDenied(props: IProps) {
    const { t } = useTranslation();

    return (
        <div className="accessDeniedWrapper">
            <img src={"./noRoomImage.png"} alt={t("Shared.accessDenied")} />
            <div className="accessDeniedColumn">
                <div className="accessDeniedTitle">{t("Shared.accessDenied")}</div>
                <div className="accessDeniedDescription">{t("Shared.accessDeniedDesc")}</div>
            </div>
            {/* <Button
                variant="secondary"
                onClick={(e) => {
                    window.location.href = "/";
                }}
            >
                <p>{t("Shared.backToMain")}</p>
            </Button> */}
        </div>
    );
}
